var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import mixpanelManager from '../helpers/mixpanelManager';
import { EMPTY_OBJECT_READONLY, CONTEXT_ID } from '../config/constants';
import { getBaseProperties } from '../saga';
import { mixpanelIdentityPath, mixpanelIdentity } from '../config';
import _once from 'lodash/once';
/*
for multiple mixpanel project tracking,
set mixpanel projectId in your env to be of form of
id1:projectA#id2:projectB#id3:projectC
*/
var RegisterTracking = /** @class */ (function (_super) {
    __extends(RegisterTracking, _super);
    function RegisterTracking(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props.user, userId = _a.id, name = _a.name, email = _a.email;
        var mixpanelId = "" + userId;
        mixpanelManager.init(mixpanelId, { userId: userId, name: name, email: email });
        return _this;
    }
    RegisterTracking.prototype.componentDidMount = function () {
        var _a = this.props, contextData = _a.contextData, globalCommonData = _a.globalCommonData, email = _a.user.email;
        mixpanelManager.setParams(__assign(__assign({ contextData: contextData }, globalCommonData), { isMindtickleUser: email.indexOf('mindtickle.com') > -1 }));
    };
    RegisterTracking.prototype.render = function () {
        return this.props.children;
    };
    return RegisterTracking;
}(PureComponent));
var mapStateToProps = function (globalState) {
    var mixpanelParams = mixpanelManager.params;
    var contextData = getContextData(globalState, mixpanelParams);
    var globalCommonData = getGlobalCommonData(globalState);
    return contextData ? { globalCommonData: globalCommonData, contextData: contextData } : EMPTY_OBJECT_READONLY;
};
var getContextData = function (store, params) {
    if (params === void 0) { params = {}; }
    var contextData = {};
    if (params.hasOwnProperty(CONTEXT_ID)) {
        var contextId = params[CONTEXT_ID];
        var contextPath = (store[contextId] && store[contextId].mixpanel) || {};
        contextData = getBaseProperties(contextPath, mixpanelIdentity.get(), store);
    }
    return contextData;
};
var getGlobalCommonData = _once(function (globalState) {
    return getBaseProperties(mixpanelIdentityPath, mixpanelIdentity.get(), globalState);
});
export default connect(mapStateToProps, null)(RegisterTracking);
//# sourceMappingURL=RegisterTracking.js.map